import React, { Component } from 'react';
import { Grid, TextField, Switch } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CustomizeResponse from './CustomizeResponse';
import useWebhookImportStore from '../useWebhookImportStore';
import config from '../../../config';
class SetEndpointUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prodCustomResponse:
        useWebhookImportStore.getState().data?.prod?.response ?? false,
      prodCustomStatus:
        useWebhookImportStore.getState().data?.prod?.status ?? 200,
      prodCustomDataType:
        useWebhookImportStore.getState().data?.prod?.dataType ?? 'JSON',
      prodCustomHeaders:
        useWebhookImportStore.getState().data?.prod?.headers ?? [
          { key: 'key', value: 'value' },
        ],
      prodCustomBody:
        useWebhookImportStore.getState().data?.prod?.body ?? '{"key": "value"}',
    };
  }

  handleCustomResponseSwitch = () => {
    useWebhookImportStore.setState(state => ({
      data: {
        ...state.data,
        prod: {
          ...state.data?.prod,
          response: !this.state.prodCustomResponse,
        },
      },
    }));
    this.setState({
      prodCustomResponse: !this.state.prodCustomResponse,
    });
  };

  render() {
    return (
      <Grid item xs={12} className="textAlignLeft">
        <Grid container display={'flex'} alignItems={'center'}>
          <Grid item xs={12}>
            <span>
              Return to the source of your webhook and switch the Sample Endpoint URL with the
              Production Endpoint URL below.
            </span>
          </Grid>
          <Grid item xs={12} marginTop={this.props.isExp ? 0 : '24px'}>
            <TextField
              value={`${config.WEBHOOK_ENDPOINT.PRODUCTION}/${this.props.component_id}`}
              className={`key_padding ${this.props.isExp && 'textFieldWebhook'}`}
              variant="outlined"
              disabled={true}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CopyToClipboard
                      text={`${config.WEBHOOK_ENDPOINT.PRODUCTION}/${this.props.component_id}`}
                    >
                      <FileCopyIcon className="custom-icon-btn" />
                    </CopyToClipboard>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid container item direction={'row'} alignItems={'center'}>
            <Switch
              checked={this.state.prodCustomResponse}
              onChange={() => {
                this.handleCustomResponseSwitch();
              }}
            ></Switch>
            <p className={'bold'}>Customize response (optional)</p>
          </Grid>
          {this.state.prodCustomResponse && (
            <CustomizeResponse
              editStatus={val => {
                this.setState({ prodCustomStatus: val });
              }}
              editBody={val => {
                this.setState({ prodCustomBody: val });
              }}
              editDataType={val => {
                this.setState({ prodCustomDataType: val });
              }}
              status={this.state.prodCustomStatus}
              dataType={this.state.prodCustomDataType}
              headers={this.state.prodCustomHeaders}
              body={this.state.prodCustomBody}
              addHeader={() => {
                this.state.prodCustomHeaders.push({
                  key: 'key',
                  value: 'value',
                });
                this.setState({
                  prodCustomHeaders: this.state.prodCustomHeaders,
                });
              }}
              editHeader={(value, index, type) => {
                this.state.prodCustomHeaders[index][type] = value;
                this.setState({
                  prodCustomHeaders: this.state.prodCustomHeaders,
                });
              }}
              deleteHeader={index => {
                this.state.prodCustomHeaders.splice(index, 1);
                this.setState({
                  prodCustomHeaders: this.state.prodCustomHeaders,
                });
              }}
            />
          )}

          <Grid item xs={12} className="dialogContentLeft">
            <Grid item xs={12}>
              <Button
                onClick={() => this.props.onChangeState(3, 3)}
                className="btnSpace"
                variant={'outlined'}
                color={'info'}
              >
                Back
              </Button>
              <Button
                onClick={() => this.props.onChangeState(5, 5)}
                // disabled={slackStore.data.endpoint_url ? false : true}
                variant={'contained'}
                color={'primary'}
              >
                {' '}
                Next
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default SetEndpointUrl;
